class ObservablePage extends HTMLElement {
  constructor() {
    super();
    this.navItem = this.querySelectorAll('nav .list-menu__item');
    this.observable = this.querySelectorAll('[data-observe] li')
    this.forSubtitles = this.querySelectorAll('[data-observe] li p strong')

    this.navItem.forEach( menuItem => {
      menuItem.addEventListener(
        'click',
        this.onItemClick.bind(this)
      );
    })
  }
  connectedCallback() {
    this.observePage()
    //this.addSubtitles();
  }
  onItemClick(e) {
    setTimeout(()=> {
      this.navItem.forEach(item=> item.classList.remove('active'))
      e.target.classList.add('active')
    },300)
  }

  observePage() {
    window.onscroll = (()=> {
      this.observable.forEach((v,i)=> {
        let rect = v.getBoundingClientRect().y
        let offset = 100;
        if (window.innerWidth > 750 ) {
          let offset = 250;
        }
        if(rect < window.innerHeight-offset){
          this.navItem.forEach(item=> item.classList.remove('active'))
          this.navItem[i].classList.add('active')
        }
      })
    })
  }
  addSubtitles() {
    this.forSubtitles.forEach(item =>
      item
        .parentElement
        .classList
        .add('subheader')
    )
  }

}
customElements.define('observable-page', ObservablePage);